import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "next-i18next"
import {
  getListFirstLineItemsData,
  addListLineItemQuantity,
} from "@/store/features/favoritesSlice"
import Loader from "@/components/Loader"

import { getTranslations } from "@/components/MyFavorites/v1/MyList/localization"
import { NumericFormat } from "react-number-format"
import { useRouter } from "next/router"
import {
  getFormattedDate,
  getListTotalPrice,
} from "@/components/MyFavorites/v1/MyList/helper"
import { PRODUCT_BEST_SELLERS } from "@/constants/routes"
import { selectGenericState } from "@/store/features/genericSlice"
import styles from "@/components/MyFavorites/v1/MyList/index.module.scss"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import Button from "@/components/core/Button/Button"
import Image from "@/components/Shared/Image"
import EditIcon from "@/public/icons/edit-list.svg"
import backToTopIcon from "@/public/icons/back-top-arrow.svg"
import SaveToList from "@/components/SaveToList"
import ListRowItem from "@/components/MyFavorites/v1/MyList/ListRowItems/v1/ListRowItems.jsx"
import ListConfirmationModal from "@/components/ListConfirmationModal"
import CONSTANTS, { EXCEPTIONAL_SITENAME } from "@/constants/index"
import { listItemQuantityChangeTypeAndValueCal } from "@/components/MyFavorites/v1/MyList/helper"

const ListDetails = props => {
  const {
    list = {},
    siteName = "",
    setSelectedList = () => {},
    deleteListSuccess = () => {},
    setIsListDetailsPage = () => {},
    presetConfigs = "",
  } = props

  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const router = useRouter()
  const {
    edit,
    moveItems,
    deleteItems,
    deleteList,
    itemPrice,
    quantity,
    total,
    item,
    listTotal,
    browseMoreProducts,
    selectAll,
    created,
    backToTop,
    editList,
  } = staticText
  const { globalConfig } = useSelector(selectGenericState)
  const {
    general = {
      swatchUrl: CONSTANTS?.COLOR_FILE_URL,
      siteName:
        EXCEPTIONAL_SITENAME.charAt(0).toUpperCase() +
        EXCEPTIONAL_SITENAME.slice(1),
    },
    internationalization: { locale = "", language = "en" } = {},
  } = globalConfig

  const currentList = list[0]
  const {
    name = "",
    description = "",
    custom: { fields: { project } = {} } = {},
  } = currentList || {}

  const [checkedItems, setCheckedItem] = useState([])
  const [nameValue, setNameValue] = useState(name[locale])
  const [descriptionValue, setDescriptionValue] = useState(description[locale])
  const [projectValue, setProjectValue] = useState(project)
  const [productData, setProductData] = useState([])
  const [allProductsData, setAllProductsData] = useState([])
  const [baseData, setBaseData] = useState([])
  const [productQtyObj, setProductQtyObj] = useState({})
  const [openForm, setOpenForm] = useState(false)
  const [openConforMationModal, setOpenConfirmationModal] = useState(false)
  const [deletList, setDeleteList] = useState(false)
  const [emptyList, setEmptyList] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [currentListVal, setCurrentListVal] = useState({})
  const [openMoveToList, setOpenMoveToList] = useState(false)
  const [selectAllCheckBoxChecked, setSelectAllCheckBoxChecked] =
    useState(false)
  const [openMultiItemsDeleteFromList, setOpenMultiItemsDeleteFromList] =
    useState(false)

  const dispatch = useDispatch()
  const handleBrowseMoreProducts = () => {
    router.push(`/${language}${PRODUCT_BEST_SELLERS}`).then(() => {
      router.reload()
    })
  }

  const handleMoveSuccessCallBack = responseData => {
    if (responseData?.deleteResponse?.lineItems.length) {
      setCurrentListVal({
        ...currentListVal,
        version: responseData?.deleteResponse?.version,
      })
      getListDetails(responseData?.deleteResponse)
      setSelectAllCheckBoxChecked(false)
      setCheckedItem([])
    } else {
      deleteListSuccess()
    }
  }
  const handleCheckBoxChecked = (e, id) => {
    if (e.target.checked) {
      setCheckedItem([...checkedItems, id])
    } else {
      const items = checkedItems.filter(pid => pid !== id)
      setCheckedItem(items)
      if (!items.length) {
        setSelectAllCheckBoxChecked(false)
      }
    }
  }

  const handleCheckBoxAllClick = e => {
    if (e.target.checked) {
      setCheckedItem(
        productData.map(product => {
          return product["ctId_s"]
        })
      )
      setSelectAllCheckBoxChecked(true)
    } else {
      setSelectAllCheckBoxChecked(false)
      setCheckedItem([])
    }
  }

  const closeMultiItemsDeleteFromList = listResponse => {
    setOpenMultiItemsDeleteFromList(false)
    if (listResponse?.lineItems.length) {
      setCurrentListVal({
        ...currentListVal,
        version: listResponse?.version,
      })
      getListDetails(listResponse)
      setSelectAllCheckBoxChecked(false)
      setCheckedItem([])
    } else {
      deleteListSuccess()
    }
  }

  const handleLoadMoreProducts = () => {
    const nextrecords = productData.length + 10
    if (nextrecords < baseData.length) {
      setProductData(baseData.slice(0, nextrecords))
      setAllProductsData(baseData.slice(nextrecords))
    } else {
      const remainingRecords = baseData.slice(productData.length)
      setProductData([...productData, ...remainingRecords])
      setAllProductsData([])
    }
  }

  const getListDetails = currentList => {
    window.scrollTo(0, 0)
    setCurrentListVal(currentList)
    setShowLoader(true)
    dispatch(getListFirstLineItemsData(currentList, true))
      .unwrap()
      .then(response => {
        const qtObject = {}
        currentList?.lineItems.forEach(lineItem => {
          qtObject[lineItem?.productId] = lineItem?.quantity
        })
        setProductQtyObj(qtObject)
        setBaseData(response)
        if (response.length > 10) {
          setProductData(response.slice(0, 10))
          setAllProductsData(response.slice(10))
        } else {
          setProductData(response)
        }
        setShowLoader(false)
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
        setShowLoader(false)
      })
    setIsListDetailsPage(true)
  }

  useEffect(() => {
    getListDetails(currentList)
    return () => {
      setIsListDetailsPage(false)
    }
  }, [])

  useEffect(() => {
    if (baseData.length > 10) {
      setProductData(baseData.slice(0, 10))
      setAllProductsData(baseData.slice(10))
    } else {
      setProductData(baseData)
    }
  }, [baseData])

  const qtyChange = async (qty, product, list) => {
    const { updatedQuantity = 1, actionType = "" } =
      listItemQuantityChangeTypeAndValueCal(qty, product, productQtyObj)
    if (!actionType) {
      return
    }
    setShowLoader(true)
    const lineItems = list[0]?.lineItems
    const lineItem = lineItems?.filter(item => {
      return item?.productId === product["ctId_s"]
    })

    dispatch(
      addListLineItemQuantity({
        listId: currentListVal?.id,
        version: currentListVal?.version,
        productId: product["ctId_s"],
        quantity: updatedQuantity,
        lineItemId: lineItem[0].id,
        variantId: lineItem[0]?.variantId,
        action: actionType,
      })
    )
      .unwrap()
      .then(response => {
        setCurrentListVal({ ...currentListVal, version: response?.version })
        const lineItem = response?.lineItems?.filter(item => {
          return item?.productId === product["ctId_s"]
        })
        const obj = { ...productQtyObj }
        obj[product["ctId_s"]] = lineItem[0]?.quantity
        setProductQtyObj(obj)
        setShowLoader(false)
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
        const obj = { ...productQtyObj }
        setProductQtyObj(obj)
        setShowLoader(false)
      })
  }
  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const closeModalWithOutDelete = () => {
    setOpenConfirmationModal(false)
    setDeleteList(false)
    setEmptyList(false)
  }

  const successCallBack = response => {
    setCurrentListVal({ ...currentListVal, version: response.version })
    setNameValue(response.name[locale])
    setDescriptionValue(response?.description[locale])
    setProjectValue(response?.custom?.fields?.project)
    setOpenForm(false)
  }

  const handleEditList = () => {
    setOpenForm(true)
  }

  const handleDeleteList = () => {
    setOpenConfirmationModal(true)
    setDeleteList(true)
    setEmptyList(list?.lineItems?.length > 0)
  }

  const closeConfirmationModal = () => {
    setOpenConfirmationModal(false)
    setDeleteList(false)
    setEmptyList(false)
    deleteListSuccess()
  }

  return (
    <div className={styles.ListDetailsWrapper}>
      <div className="list-title">
        <div className="list-title-left">
          <div className="listName">
            <div className="list-name-box">
              <span>{nameValue}</span>
              <div className="edit-box" onClick={handleEditList}>
                <Image src={EditIcon} alt="edit icon image" />
                <span className="edit-text">{edit}</span>
              </div>
            </div>
          </div>
          <p className="listDescription">{descriptionValue}</p>
          <p className="created-at-text">
            {created}: {getFormattedDate(currentList)}
          </p>
          <p className="created-at-text">{projectValue}</p>
        </div>
        <div className="list-title-right">
          <div className="delete-list-cta" onClick={handleDeleteList}>
            {deleteList}
          </div>
        </div>
      </div>
      {productData?.length > 0 ? (
        <>
          <div className="list-select-all-move-items-delete-items">
            <div className="select-all-box">
              <div className="select-all-checkbox">
                <Checkbox
                  onChange={handleCheckBoxAllClick}
                  checked={selectAllCheckBoxChecked}
                />
              </div>
              <span className="select-all-text">{selectAll}</span>
            </div>
            <div className="move-items-delete-items-box">
              <Button
                role="button"
                size="small"
                flexible
                type="ghost"
                disabled={checkedItems?.length ? false : true}
                label={moveItems}
                onClick={() => {
                  setOpenMoveToList(true)
                }}
              />
              <Button
                role="button"
                size="small"
                flexible
                type="ghost"
                disabled={checkedItems?.length ? false : true}
                label={deleteItems}
                onClick={() => {
                  setOpenMultiItemsDeleteFromList(true)
                }}
              />
            </div>
          </div>
          <div className="list-landing">
            <div className="list-grid">
              <div
                className={`row cart-items__th no-gutters ${
                  productData?.length > 0
                    ? "cart-table-header-list display-none"
                    : ""
                }`}
              >
                <div
                  className="col-4 d-none d-sm-block text-left cart-items__td px-0 col-md-6 display-none"
                  aria-hidden="true"
                >
                  {item}
                </div>
                <div className="col-12 col-sm-6 col-md-6">
                  <div className="row mx-0 px-0">
                    <div
                      className="col-4 d-none d-sm-block  cart-items__td cart-td-unit-price display-none"
                      aria-hidden="true"
                    >
                      {itemPrice}
                    </div>
                    <div
                      className="col-4 d-none d-sm-block text-center cart-items__td px-0 display-none"
                      aria-hidden="true"
                    >
                      {quantity}
                    </div>

                    <div
                      className="col-4 d-none d-sm-block text-right cart-items__td px-0 display-none"
                      aria-hidden="true"
                    >
                      {total}
                    </div>
                  </div>
                </div>
              </div>
              {productData?.length > 0
                ? productData.map((product, index) => {
                    return (
                      <ListRowItem
                        key={index}
                        presetConfigs={presetConfigs}
                        product={product}
                        general={general}
                        siteName={siteName}
                        productQtyObj={productQtyObj}
                        checkedItems={checkedItems}
                        list={list[0]}
                        handleCheckBoxChecked={handleCheckBoxChecked}
                        qtyChange={(qty, product) => {
                          qtyChange(qty, product, list)
                        }}
                      />
                    )
                  })
                : null}
            </div>
            <div
              className="list-footer"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {window.innerWidth > 812 ? (
                <div
                  className="list-browse-more-text"
                  onClick={handleBrowseMoreProducts}
                >
                  {browseMoreProducts}
                </div>
              ) : null}

              <div className="list-total-text display-none">
                {listTotal}:
                <span style={{ paddingLeft: "20px" }}>
                  <NumericFormat
                    value={getListTotalPrice(baseData, productQtyObj)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix="$"
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </span>
              </div>
            </div>
            {allProductsData.length ? (
              <div className="load-more-button">
                <Button
                  label="Load More"
                  role="button"
                  size="small"
                  flexible
                  type="ghost"
                  onClick={handleLoadMoreProducts}
                />
              </div>
            ) : null}
            <div className="list-back-to-top">
              <button
                role="link"
                className={"go-back-button"}
                onClick={handleBackToTop}
              >
                <span className={"go-back-text"}>{backToTop}</span>
                <img
                  className={"go-back-image"}
                  aria-hidden="true"
                  src={backToTopIcon?.src}
                  alt={backToTop}
                />
              </button>
            </div>
          </div>
        </>
      ) : null}
      {openForm ? (
        <SaveToList
          showListSaveAndCreate={true}
          createList={true}
          listSaveAndCreateClose={() => {
            setOpenForm(false)
          }}
          listData={{
            name: nameValue,
            description: descriptionValue,
            project: projectValue,
          }}
          editListText={editList}
          selectedListDetails={list}
          handleSuccessCallBack={successCallBack}
        />
      ) : null}
      {openConforMationModal ? (
        <ListConfirmationModal
          list={currentListVal}
          openConforMationModal={openConforMationModal}
          noLineItems={emptyList}
          deletefromListDetails={deletList}
          closeConformationModal={closeConfirmationModal}
          setSelectedList={setSelectedList}
          closeModalWithOutDelete={closeModalWithOutDelete}
        />
      ) : null}
      {showLoader ? <Loader /> : null}
      {openMoveToList ? (
        <SaveToList
          showListSaveAndCreate={true}
          moveToList={true}
          listSaveAndCreateClose={() => {
            setOpenMoveToList(false)
          }}
          moveOrDeleteFromListName={nameValue}
          currentList={currentListVal}
          productData={productData}
          productQtyObj={productQtyObj}
          selectedItems={checkedItems}
          handleSuccessCallBack={handleMoveSuccessCallBack}
        />
      ) : null}
      {openMultiItemsDeleteFromList ? (
        <ListConfirmationModal
          list={currentListVal}
          openConforMationModal={openMultiItemsDeleteFromList}
          selectedItems={checkedItems}
          multiDeleteFromList={true}
          listName={nameValue}
          handleSuccessCallBack={closeMultiItemsDeleteFromList}
          closeModalWithOutDelete={() => {
            setOpenMultiItemsDeleteFromList(false)
          }}
        />
      ) : null}
    </div>
  )
}

export default ListDetails
